import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import OrderManagement from './components/OrderManagement';

const { Cell } = ResponsiveGrid;

const GroupBuyingSettingAndManagement = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="團購訂單管理"
        breadcrumbs={[
          {
            name: '團購管理',
          },
          {
            name: '團購訂單管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <OrderManagement />
    </Cell>
  </ResponsiveGrid>
);

export default GroupBuyingSettingAndManagement;
